import { SVGProps } from 'react';

const SvgChartSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M.98 7.646a.5.5 0 0 1 .353-.146H4a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H1.333a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .147-.354Zm.853.854v5H3.5v-5H1.833ZM6.313 1.646a.5.5 0 0 1 .354-.146h2.666a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H6.667a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .146-.354Zm.854.854v11h1.666v-11H7.167ZM11.646 4.313A.5.5 0 0 1 12 4.167h2.667a.5.5 0 0 1 .5.5V14a.5.5 0 0 1-.5.5H12a.5.5 0 0 1-.5-.5V4.667a.5.5 0 0 1 .146-.354Zm.854.854V13.5h1.667V5.167H12.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChartSmall;
